import { FREE_ROUNDS_PER_DAY, PRO_PRICE } from "./Plan"
import { SiteFooter, TopicRequestLine } from "./SiteFooter"

// The signed-out homepage. It must make no API calls: every data endpoint is
// behind auth, and a 401 here would bounce the visitor straight to /login.
export function Landing() {
	return (
		<div class="h-100 overflow-auto">
			<div class="container page">
				<div class="stack gap-3 text-center">
					<div class="inline-flex center gap-2 mx-auto">
						<img src="/static/brand/logo.svg" alt="" width="32" height="32" />
						<span class="brand-name">Quizfish</span>
					</div>
					<p class="lead">
						Ten questions, on any topic, solo or challenge against a friend.
					</p>
					<div class="flex wrap center jc-center gap-2">
						<a href="/login" class="btn primary lg">
							Log in
						</a>
						<a href="/signup">Sign up</a>
					</div>
					<p class="muted small">
						Open to anyone. You'll get an email to verify your address before
						you can play.
					</p>
				</div>

				<div class="grid-2">
					<div class="stack gap-2">
						<h2>Play solo</h2>
						<p class="muted">
							Pick a topic, answer ten questions, at your pace, then review what
							you missed and what the right answer was.
						</p>
					</div>
					<div class="stack gap-2">
						<h2>Play together with a friend</h2>
						<p class="muted">
							Challenge someone and you both get the <em>same</em> ten
							questions. Each point goes to whoever answers it correctly first.
						</p>
					</div>
				</div>

				<p class="muted">
					Twenty-three topics and counting — capitals, flags, country outlines
					and mental arithmetic; continents and the state capitals of India and
					the United States; numbers written out in words, up to 999; and,
					designed for a five-year-old, animals, counting, first letters,
					spelling numbers and opposites. Every round is generated fresh, so no
					two plays are quite the same.
				</p>
				<TopicRequestLine />

				<p class="muted small">
					The free plan gives you {FREE_ROUNDS_PER_DAY} rounds a day, counting
					solo rounds and the challenges you send. Accepting a friend's
					challenge is always free. Pro is unlimited rounds for {PRO_PRICE}, and
					you can cancel any time. Every topic is in both.
				</p>

				<SiteFooter />
			</div>
		</div>
	)
}
